// w11.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W11 = () => {
  return <WW config={pageConfigs.w11} />;
};

export default W11;
